import { render, staticRenderFns } from "./ObjetoTab.vue?vue&type=template&id=1c941cac"
import script from "./ObjetoTab.vue?vue&type=script&lang=js"
export * from "./ObjetoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports